import { render, staticRenderFns } from "./ApmsRegPlantProtectionInfoDetail2.vue?vue&type=template&id=a98efdf2&scoped=true&"
import script from "./ApmsRegPlantProtectionInfoDetail2.vue?vue&type=script&lang=js&"
export * from "./ApmsRegPlantProtectionInfoDetail2.vue?vue&type=script&lang=js&"
import style0 from "./ApmsRegPlantProtectionInfoDetail2.vue?vue&type=style&index=0&id=a98efdf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98efdf2",
  null
  
)

export default component.exports